import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxToastrService } from '@core/services';
import { ProvidersService, ProviderType } from '@core/services/providers.service';
import { ProviderItem } from '@core/models/providers';
import { TranslateService } from '@ngx-translate/core';
import { take } from "rxjs/operators";

@Component({
  selector: 'app-providers-function',
  templateUrl: './providers-function.component.html',
  styleUrls: ['./providers-function.component.scss']
})
export class ProvidersFunctionComponent implements OnInit {

  @Input() initialType: ProviderType = 'hotel';

  loading = false;
  list: ProviderItem[] = [];
  types: { value: ProviderType; label: string }[] = [
    { value: 'hotel',   label: 'Hoteles'  },
    { value: 'flight',  label: 'Vuelos'   },
    { value: 'train',   label: 'Trenes'   },
    { value: 'car',     label: 'Coches'   },
    { value: 'expense', label: 'Servicios personalizados'   },
  ];

  form = this.fb.group({
    type: [this.initialType, Validators.required],
    name: ['', [Validators.required]],
  });

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private providerService: ProvidersService,
    public translate: TranslateService,
    private ngxToastrService: NgxToastrService
  ) {}

  ngOnInit(): void {
    this.loadProviders();
    this.form.get('type')!.valueChanges.subscribe(() => this.loadProviders());
  }

  get currentType(): ProviderType {
    return this.form.get('type')!.value as ProviderType;
  }

  loadProviders(): void {
    this.loading = true;
    this.providerService.getProviders(this.currentType).subscribe({
      next: (items) => {
        this.list = items || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.translate
          .get("common.error-loading-providers")
          .pipe(take(1))
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.error || '');
        });
      }
    });
  }

  addProvider(): void {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    const name = (this.form.get('name')!.value || '').trim();
    if (!name) return;

    this.loading = true;
    this.providerService.createProvider(this.currentType, name).subscribe({
      next: (created) => {
        this.translate
          .get("common.created-provider")
          .subscribe((result) => {
            this.ngxToastrService.typeSuccess(null, result);
          });
        this.list.unshift(created);

        const nameCtrl = this.form.get('name')!;
        nameCtrl.reset('', { emitEvent: false });
        nameCtrl.setErrors(null);
        nameCtrl.markAsPristine();
        nameCtrl.markAsUntouched();
        nameCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });

        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.translate
        .get(['common.error-created-provider', 'common.provider-exists'])
        .pipe(take(1))
        .subscribe(t => {
          const msg =
            err?.status === 409
              ? t['common.provider-exists']
              : (err?.error?.message || '');
          this.ngxToastrService.typeInfo(t['common.error-created-provider'], msg);
        });

      }
    });
  }

  deleteProvider(item: ProviderItem): void {
    if (!item) return;
    this.loading = true;
    const nameKey = item.name;
    this.providerService.deleteProvider(this.currentType, nameKey).subscribe({
      next: () => {
        this.translate
          .get("common.deleted-provider")
          .subscribe((result) => {
            this.ngxToastrService.typeSuccess(null, result);
          });
        this.list = this.list.filter(p => (p.uuid || p.name) !== (item.uuid || item.name));
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.translate
          .get("common.error-deleted-provider")
          .pipe(take(1))
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.error || '');
        });
      }
    });
  }


}
